import { Component, OnInit } from "@angular/core";
import * as _ from "lodash";

@Component({
    selector: "app-rx-delivery-info",
    templateUrl: "./rx-delivery-info.component.html",
    standalone: false
})
export class RxDeliveryInfoComponent implements OnInit {

    constructor() { }

    ngOnInit() {
        
    }

}
